
import React from 'react';

export const Pagination = ({ 
  currentPage,
  lastPage,
  total,
  itemRange,
  pageNumbers,
  onPageChange 
}) => {
  return (
    <div className="border-t border-gray-200 px-4 py-3 flex items-center justify-between">
      <div className="flex-1 flex justify-between items-center">
        <div>
          <p className="text-sm text-gray-700">
            Showing <span className="font-medium">{itemRange.start}</span>{' '}
            to <span className="font-medium">{itemRange.end}</span>{' '}
            of <span className="font-medium">{total}</span> results
          </p>
        </div>
        <div className="flex gap-1">
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage <= 1}
            className="relative inline-flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Previous
          </button>
          {pageNumbers.map((pageNum) => (
            <button
              key={pageNum}
              onClick={() => onPageChange(pageNum)}
              className={`relative inline-flex items-center px-3 py-2 text-sm font-medium rounded-md ${
                pageNum === currentPage
                  ? 'bg-[#1330C5] text-white'
                  : 'text-gray-700 bg-white hover:bg-gray-50'
              }`}
            >
              {pageNum}
            </button>
          ))}
          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage >= lastPage}
            className="relative inline-flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};



  {/* <Pagination
            currentPage={pagination.currentPage}
            lastPage={pagination.lastPage}
            total={pagination.total}
            itemRange={getItemRange()}
            pageNumbers={getPageNumbers()}
            onPageChange={handlePageChange}
          /> */}